import { getAxiosClient } from "../../HttpsService";
import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  Field,
  RecordType,
  SourceMap,
  TableFields,
} from "./recordTypes-interface";

export const fetchRecordTypesByApplication = createAsyncThunk(
  "recordTypes/fetchRecordTypesByApplication",
  async (appUuid: string) => {
    const client = getAxiosClient();
    const response = await client.get(
      `api/eza_app_record_type/app-uuid/${appUuid}`
    );
    return response.data as RecordType[];
  }
);

export const fetchRecordTypes = createAsyncThunk(
  "recordTypes/fetchRecordTypes",
  async () => {
    const client = getAxiosClient();
    const response = await client.get(`api/eza_app_record_type`);
    return response.data as RecordType[];
  }
);

export const fetchRecordTypesById = createAsyncThunk(
  "recordTypes/fetchRecordTypesById",
  async (uuid: string) => {
    const client = getAxiosClient();
    const response = await client.get(`api/eza_app_record_type/uuid/${uuid}`);
    return response.data as {
      recordType: RecordType;
      sourceMap: SourceMap[];
      fields: Field[];
    };
  }
);

export const fetchTables = createAsyncThunk(
  "recordTypes/fetchTables",
  async (uuid: string) => {
    const response = await fetch(
      (process.env.REACT_APP_RULE_ENGINE_URL as string) +
        `/get-tables?id=${uuid}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return (await response.json()) as string[];
  }
);

export const fetchTableFields = createAsyncThunk(
  "recordTypes/fetchTableFields",
  async ({ uuid, table }: { uuid: string; table: string }) => {
    const response = await fetch(
      (process.env.REACT_APP_RULE_ENGINE_URL as string) +
        `/get-tables-fields?id=${uuid}&table=${table}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    return (await response.json()) as TableFields[];
  }
);
